import { render, staticRenderFns } from "./ReleaseInfoBox.vue?vue&type=template&id=2e0cf842&"
import script from "./ReleaseInfoBox.vue?vue&type=script&lang=js&"
export * from "./ReleaseInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseInfoBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports